import React, { useEffect, useState } from "react";
import TornaAlMenu from "../components/TornaAlMenu";
import { authFetch } from "../utils/authFetch";

const API_URL = process.env.REACT_APP_API_URL || "";

export default function AppMarketingPage() {
  const [clienti, setClienti] = useState([]);
  const [appClienti, setAppClienti] = useState([]);
  const [campaigns, setCampaigns] = useState([]);
  const [templates, setTemplates] = useState([]);
  const [previewTemplate, setPreviewTemplate] = useState(null);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState("");

  const [testEmail, setTestEmail] = useState("");
  const [subject, setSubject] = useState("Promo Dallo Zio Roby");
  const [message, setMessage] = useState("Ciao! Ecco una nuova promozione disponibile per te sull'app Dallo Zio Roby.");
  const [imagePreview, setImagePreview] = useState("");
  const [imageFile, setImageFile] = useState(null);
  const [testResult, setTestResult] = useState("");

  const [notificationMode, setNotificationMode] = useState("single");
  const [selectedClientCodes, setSelectedClientCodes] = useState([]);
  const [notificationTitle, setNotificationTitle] = useState("");
  const [notificationMessage, setNotificationMessage] = useState("");
  const [notificationMarketingOnly, setNotificationMarketingOnly] = useState(false);
  const [notificationResult, setNotificationResult] = useState("");
  const [notificationSending, setNotificationSending] = useState(false);

  useEffect(() => {
    const load = async () => {
      setLoading(true);
      setErr("");

      try {
        const res = await authFetch(`${API_URL}/api/clienti/`);
        const data = await res.json().catch(() => ({}));

        if (!res.ok) {
          throw new Error(data?.detail || "Errore caricamento clienti.");
        }

        const templatesRes = await authFetch(`${API_URL}/api/app/marketing/templates/`);
        if (templatesRes.ok) {
          const templatesData = await templatesRes.json().catch(() => []);
          setTemplates(Array.isArray(templatesData) ? templatesData : []);
        }

        const campaignsRes = await authFetch(`${API_URL}/api/app/marketing/campaigns/`);
        if (campaignsRes.ok) {
          const campaignsData = await campaignsRes.json().catch(() => []);
          setCampaigns(Array.isArray(campaignsData) ? campaignsData : []);
        }

        const list = Array.isArray(data) ? data : (data.results || []);

        setAppClienti(
          list.filter((c) => c?.registered_from_app)
        );

        setClienti(
          list.filter((c) =>
            c?.registered_from_app &&
            c?.marketing_consent &&
            c?.email
          )
        );
      } catch (e) {
        setErr(e.message || "Errore imprevisto.");
      } finally {
        setLoading(false);
      }
    };

    load();
  }, []);

  const emails = clienti.map((c) => c.email).filter(Boolean);

  const onImageChange = (e) => {
    const file = e.target.files?.[0];
    if (!file) {
      setImageFile(null);
      setImagePreview("");
      return;
    }

    setImageFile(file);

    const reader = new FileReader();
    reader.onload = () => setImagePreview(String(reader.result || ""));
    reader.readAsDataURL(file);
  };

  const sendTestFake = async () => {
    if (!testEmail.trim()) {
      setTestResult("Inserisci una email destinatario test.");
      return;
    }

    try {
      setTestResult("Invio email test in corso...");

      const formData = new FormData();
      formData.append("email", testEmail.trim());
      formData.append("subject", subject);
      formData.append("message", message);
      if (imageFile) formData.append("image", imageFile);

      const res = await authFetch(`${API_URL}/api/app/marketing/send-test/`, {
        method: "POST",
        body: formData,
      });

      const data = await res.json().catch(() => ({}));

      if (!res.ok) {
        throw new Error(data?.detail || "Errore invio email test.");
      }

      setTestResult(data?.detail || "Email test inviata.");
    } catch (e) {
      setTestResult(e.message || "Errore imprevisto durante invio email test.");
    }
  };


  const saveTemplate = async () => {
    const name = window.prompt("Nome template", subject || "Nuovo template");
    if (!name) return;

    try {
      const res = await authFetch(`${API_URL}/api/app/marketing/templates/`, {
        method: "POST",
        body: {
          name,
          subject,
          message,
          image_name: imageFile?.name || "",
        },
      });

      const data = await res.json().catch(() => ({}));

      if (!res.ok) {
        throw new Error(data?.detail || "Errore salvataggio template.");
      }

      const templatesRes = await authFetch(`${API_URL}/api/app/marketing/templates/`);
      if (templatesRes.ok) {
        const templatesData = await templatesRes.json().catch(() => []);
        setTemplates(Array.isArray(templatesData) ? templatesData : []);
      }

      setTestResult("Template salvato.");
    } catch (e) {
      setTestResult(e.message || "Errore salvataggio template.");
    }
  };

  const loadTemplate = (tpl) => {
    setSubject(tpl.subject || "");
    setMessage(tpl.message || "");
    setTestResult(`Template caricato: ${tpl.name}`);
  };

  const editTemplate = async (tpl) => {
    const name = window.prompt("Nome template", tpl.name || "");
    if (!name) return;

    const newSubject = window.prompt("Oggetto template", tpl.subject || "");
    if (!newSubject) return;

    const newMessage = window.prompt("Messaggio template", tpl.message || "");
    if (!newMessage) return;

    try {
      const res = await authFetch(`${API_URL}/api/app/marketing/templates/${tpl.id}/`, {
        method: "PATCH",
        body: {
          name,
          subject: newSubject,
          message: newMessage,
          image_name: tpl.image_name || "",
        },
      });

      const data = await res.json().catch(() => ({}));

      if (!res.ok) {
        throw new Error(data?.detail || "Errore modifica template.");
      }

      const updated = data?.template || {
        ...tpl,
        name,
        subject: newSubject,
        message: newMessage,
        image_name: tpl.image_name || "",
      };

      setTemplates((prev) => prev.map((x) => (x.id === tpl.id ? updated : x)));
      setPreviewTemplate((prev) => (prev?.id === tpl.id ? updated : prev));
      setTestResult(`Template modificato: ${updated.name}`);
    } catch (e) {
      setTestResult(e.message || "Errore modifica template.");
    }
  };

  const deleteTemplate = async (tpl) => {
    const ok = window.confirm(`Eliminare il template "${tpl.name}"?`);
    if (!ok) return;

    try {
      const res = await authFetch(`${API_URL}/api/app/marketing/templates/${tpl.id}/`, {
        method: "DELETE",
      });

      if (!res.ok) {
        const data = await res.json().catch(() => ({}));
        throw new Error(data?.detail || "Errore eliminazione template.");
      }

      setTemplates((prev) => prev.filter((x) => x.id !== tpl.id));
      setPreviewTemplate((prev) => (prev?.id === tpl.id ? null : prev));
      setTestResult(`Template eliminato: ${tpl.name}`);
    } catch (e) {
      setTestResult(e.message || "Errore eliminazione template.");
    }
  };

  const sendBulk = async () => {
    if (!subject.trim()) {
      setTestResult("Inserisci oggetto email.");
      return;
    }

    if (!message.trim()) {
      setTestResult("Inserisci messaggio email.");
      return;
    }

    if (!clienti.length) {
      setTestResult("Nessun iscritto marketing con email disponibile.");
      return;
    }

    const ok = window.confirm(`Confermi l'invio della comunicazione a ${clienti.length} iscritti marketing?`);
    if (!ok) return;

    try {
      setTestResult(`Invio comunicazione a ${clienti.length} iscritti in corso...`);

      const formData = new FormData();
      formData.append("subject", subject);
      formData.append("message", message);
      formData.append("confirm", "true");
      if (imageFile) formData.append("image", imageFile);

      const res = await authFetch(`${API_URL}/api/app/marketing/send-bulk/`, {
        method: "POST",
        body: formData,
      });

      const data = await res.json().catch(() => ({}));

      if (!res.ok) {
        throw new Error(data?.detail || "Errore invio agli iscritti.");
      }

      const failed = Number(data?.failed_count || 0);
      setTestResult(`${data?.detail || "Invio completato."}${failed ? ` Errori: ${failed}` : ""}`);
    } catch (e) {
      setTestResult(e.message || "Errore imprevisto durante invio agli iscritti.");
    }
  };

  const quickNotifications = [
    {
      label: "Buon compleanno",
      title: "Buon compleanno da Dallo Zio Roby!",
      message: "Tanti auguri! Abbiamo pensato a una sorpresa speciale per il tuo compleanno.",
    },
    {
      label: "Ti aspetta un regalo",
      title: "Abbiamo una sorpresa per te",
      message: "Passa a trovarci da Dallo Zio Roby: abbiamo una sorpresa riservata a te.",
    },
    {
      label: "Nuovi vini disponibili",
      title: "Nuovi vini disponibili",
      message: "Sono arrivati nuovi vini da Dallo Zio Roby. Apri l'app o passa in negozio per scoprirli.",
    },
    {
      label: "Wallet ricaricato",
      title: "Wallet aggiornato",
      message: "Il tuo Wallet Dallo Zio Roby ? stato aggiornato. Puoi controllare subito il saldo direttamente dall'app.",
    },
    {
      label: "Ordine pronto",
      title: "Il tuo ordine ? pronto",
      message: "Il tuo ordine ? pronto per il ritiro. Ti aspettiamo da Dallo Zio Roby.",
    },
  ];

  const applyQuickNotification = (tpl) => {
    setNotificationTitle(tpl.title);
    setNotificationMessage(tpl.message);
    setNotificationResult("");
  };

  const toggleNotificationClient = (code) => {
    setSelectedClientCodes((prev) =>
      prev.includes(code)
        ? prev.filter((x) => x !== code)
        : [...prev, code]
    );
  };

  const sendAppNotification = async () => {
    setNotificationResult("");

    if (!notificationTitle.trim()) {
      setNotificationResult("Inserisci il titolo della notifica.");
      return;
    }

    if (!notificationMessage.trim()) {
      setNotificationResult("Inserisci il messaggio della notifica.");
      return;
    }

    if (notificationMode === "single" && selectedClientCodes.length !== 1) {
      setNotificationResult("Seleziona un cliente.");
      return;
    }

    if (notificationMode === "multiple" && selectedClientCodes.length === 0) {
      setNotificationResult("Seleziona almeno un cliente.");
      return;
    }

    const eligibleClients = appClienti.filter(
      (c) => !notificationMarketingOnly || c?.marketing_consent
    );

    let recipientCount = eligibleClients.length;

    if (notificationMode === "single") {
      recipientCount = 1;
    }

    if (notificationMode === "multiple") {
      recipientCount = selectedClientCodes.filter((code) =>
        eligibleClients.some((c) => c.code === code)
      ).length;
    }

    if (recipientCount <= 0) {
      setNotificationResult("Nessun destinatario valido.");
      return;
    }

    const ok = window.confirm(
      `Confermi l'invio della notifica a ${recipientCount} cliente/i?`
    );

    if (!ok) return;

    try {
      setNotificationSending(true);
      setNotificationResult("Invio notifica in corso...");

      const res = await authFetch(
        `${API_URL}/api/clienti/app-notifications/send/`,
        {
          method: "POST",
          body: {
            mode: notificationMode,
            client_codes:
              notificationMode === "all" ? [] : selectedClientCodes,
            title: notificationTitle.trim(),
            message: notificationMessage.trim(),
            marketing_only: notificationMarketingOnly,
          },
        }
      );

      const data = await res.json().catch(() => ({}));

      if (!res.ok) {
        throw new Error(data?.detail || "Errore invio notifica.");
      }

      setNotificationResult(
        data?.detail || `Notifica inviata a ${data?.sent_count || recipientCount} cliente/i.`
      );
    } catch (e) {
      setNotificationResult(
        e.message || "Errore imprevisto durante invio notifica."
      );
    } finally {
      setNotificationSending(false);
    }
  };

  return (
    <div className="container py-4">
      <TornaAlMenu to="/gestione-app-clienti" />

      <div className="d-flex flex-wrap justify-content-between align-items-center gap-3 mb-4">
        <div>
          <div className="text-muted small text-uppercase fw-semibold">
            Comunicazioni App
          </div>
          <h1 className="fw-bold mb-1">Mailing List App</h1>
          <div className="text-muted">
            Clienti registrati da app che hanno dato consenso a ricevere promozioni e offerte.
          </div>
        </div>

        <span className="badge text-bg-success fs-6 rounded-pill">
          {clienti.length} iscritti marketing
        </span>
      </div>

      {loading && <div className="alert alert-info">Caricamento iscritti…</div>}
      {err && <div className="alert alert-danger">{err}</div>}

      {!loading && !err && (
        <>
          <div className="card border-0 shadow-sm rounded-4 mb-4">
            <div className="card-body p-4">
              <div className="d-flex flex-wrap justify-content-between align-items-start gap-3 mb-4">
                <div>
                  <div className="text-muted small text-uppercase fw-semibold">
                    Notifiche App
                  </div>
                  <h4 className="fw-bold mb-1">Invia una notifica ai clienti</h4>
                  <div className="text-muted">
                    Invia una comunicazione direttamente nella sezione Notifiche dell'app cliente.
                  </div>
                </div>

                <span className="badge text-bg-primary rounded-pill fs-6">
                  {appClienti.length} clienti App
                </span>
              </div>

              {notificationResult && (
                <div className="alert alert-info rounded-4">
                  {notificationResult}
                </div>
              )}

              <div className="mb-4">
                <label className="form-label fw-semibold">Messaggi rapidi</label>

                <div className="d-flex flex-wrap gap-2">
                  {quickNotifications.map((tpl) => (
                    <button
                      key={tpl.label}
                      type="button"
                      className="btn btn-outline-secondary btn-sm rounded-pill"
                      onClick={() => applyQuickNotification(tpl)}
                    >
                      {tpl.label}
                    </button>
                  ))}
                </div>

                <div className="form-text">
                  Il titolo e il messaggio precompilati restano sempre modificabili prima dell'invio.
                </div>
              </div>

              <div className="mb-4">
                <label className="form-label fw-semibold d-block">
                  Destinatari
                </label>

                <div className="d-flex flex-wrap gap-3">
                  <label className="form-check">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="notificationMode"
                      value="single"
                      checked={notificationMode === "single"}
                      onChange={() => {
                        setNotificationMode("single");
                        setSelectedClientCodes([]);
                      }}
                    />
                    <span className="form-check-label">Singolo cliente</span>
                  </label>

                  <label className="form-check">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="notificationMode"
                      value="multiple"
                      checked={notificationMode === "multiple"}
                      onChange={() => {
                        setNotificationMode("multiple");
                        setSelectedClientCodes([]);
                      }}
                    />
                    <span className="form-check-label">Pi? clienti</span>
                  </label>

                  <label className="form-check">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="notificationMode"
                      value="all"
                      checked={notificationMode === "all"}
                      onChange={() => {
                        setNotificationMode("all");
                        setSelectedClientCodes([]);
                      }}
                    />
                    <span className="form-check-label">Tutti i clienti App</span>
                  </label>
                </div>
              </div>

              {notificationMode === "single" && (
                <div className="mb-3">
                  <label className="form-label fw-semibold">
                    Cliente
                  </label>

                  <select
                    className="form-select"
                    value={selectedClientCodes[0] || ""}
                    onChange={(e) =>
                      setSelectedClientCodes(
                        e.target.value ? [e.target.value] : []
                      )
                    }
                  >
                    <option value="">Seleziona cliente...</option>

                    {appClienti
                      .filter(
                        (c) =>
                          !notificationMarketingOnly ||
                          c?.marketing_consent
                      )
                      .map((c) => (
                        <option key={c.id || c.code} value={c.code}>
                          {`${c.first_name || ""} ${c.last_name || ""}`.trim() || c.name || c.email}
                          {c.code ? ` - ${c.code}` : ""}
                        </option>
                      ))}
                  </select>
                </div>
              )}

              {notificationMode === "multiple" && (
                <div className="mb-3">
                  <label className="form-label fw-semibold">
                    Seleziona clienti
                  </label>

                  <div
                    className="border rounded-4 p-3"
                    style={{ maxHeight: 260, overflowY: "auto" }}
                  >
                    {appClienti
                      .filter(
                        (c) =>
                          !notificationMarketingOnly ||
                          c?.marketing_consent
                      )
                      .map((c) => (
                        <div
                          className="form-check mb-2"
                          key={c.id || c.code}
                        >
                          <input
                            className="form-check-input"
                            type="checkbox"
                            id={`notif-client-${c.code}`}
                            checked={selectedClientCodes.includes(c.code)}
                            onChange={() => toggleNotificationClient(c.code)}
                          />

                          <label
                            className="form-check-label"
                            htmlFor={`notif-client-${c.code}`}
                          >
                            <span className="fw-semibold">
                              {`${c.first_name || ""} ${c.last_name || ""}`.trim() || c.name || c.email}
                            </span>

                            {c.code && (
                              <span className="text-muted">
                                {" "}? {c.code}
                              </span>
                            )}
                          </label>
                        </div>
                      ))}
                  </div>

                  <div className="form-text">
                    {selectedClientCodes.length} cliente/i selezionato/i
                  </div>
                </div>
              )}

              {notificationMode === "all" && (
                <div className="alert alert-warning rounded-4">
                  La notifica verr? inviata a tutti i clienti registrati nell'app
                  {notificationMarketingOnly
                    ? " che hanno anche il consenso marketing attivo."
                    : "."}
                </div>
              )}

              <div className="form-check mb-4">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="notificationMarketingOnly"
                  checked={notificationMarketingOnly}
                  onChange={(e) => {
                    setNotificationMarketingOnly(e.target.checked);
                    setSelectedClientCodes([]);
                  }}
                />

                <label
                  className="form-check-label"
                  htmlFor="notificationMarketingOnly"
                >
                  Solo clienti con consenso marketing
                </label>

                <div className="form-text">
                  Attivalo quando la notifica contiene promozioni o comunicazioni commerciali.
                </div>
              </div>

              <div className="row g-3">
                <div className="col-12">
                  <label className="form-label fw-semibold">
                    Titolo notifica
                  </label>

                  <input
                    className="form-control"
                    value={notificationTitle}
                    onChange={(e) => setNotificationTitle(e.target.value)}
                    maxLength={180}
                    placeholder="Es. Buon compleanno da Dallo Zio Roby!"
                  />
                </div>

                <div className="col-12">
                  <label className="form-label fw-semibold">
                    Messaggio
                  </label>

                  <textarea
                    className="form-control"
                    rows="5"
                    value={notificationMessage}
                    onChange={(e) => setNotificationMessage(e.target.value)}
                    placeholder="Scrivi qui il messaggio che il cliente vedr? nell'app..."
                  />
                </div>
              </div>

              <div className="d-flex justify-content-end mt-4">
                <button
                  type="button"
                  className="btn btn-primary rounded-pill px-4 fw-semibold"
                  onClick={sendAppNotification}
                  disabled={notificationSending}
                >
                  {notificationSending
                    ? "Invio in corso..."
                    : "Invia notifica"}
                </button>
              </div>
            </div>
          </div>

          <div className="d-flex align-items-center gap-2 mt-4 mb-3">
            <div>
              <div className="text-muted small text-uppercase fw-semibold">
                Mailing List
              </div>
              <h4 className="fw-bold mb-0">Email promozionali</h4>
            </div>
          </div>
          <div className="card border-0 shadow-sm rounded-4 mb-3">
            <div className="card-body">
              <h5 className="fw-bold mb-3">📧 Mail test promozione</h5>

              <div className="alert alert-info small">
                Qui prepariamo la promo e la proviamo su una singola email test.
                L'invio reale agli iscritti verrà collegato solo dopo verifica.
              </div>

              {testResult && <div className="alert alert-warning">{testResult}</div>}

              <div className="row g-3">
                <div className="col-md-6">
                  <label className="form-label fw-semibold">Email destinatario test</label>
                  <input
                    type="email"
                    className="form-control"
                    value={testEmail}
                    onChange={(e) => setTestEmail(e.target.value)}
                    placeholder="es. tua@email.it"
                  />
                </div>

                <div className="col-md-6">
                  <label className="form-label fw-semibold">Oggetto</label>
                  <input
                    className="form-control"
                    value={subject}
                    onChange={(e) => setSubject(e.target.value)}
                  />
                </div>

                <div className="col-12">
                  <label className="form-label fw-semibold">Messaggio</label>
                  <textarea
                    className="form-control"
                    rows="4"
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                  />
                </div>

                <div className="col-12">
                  <label className="form-label fw-semibold">Immagine promo</label>
                  <input
                    type="file"
                    accept="image/*"
                    className="form-control"
                    onChange={onImageChange}
                  />
                  <div className="form-text">
                    Per ora viene mostrata in anteprima. Poi la collegheremo all'invio email reale.
                  </div>
                </div>
              </div>

              <div className="card mt-4 border rounded-4">
                <div className="card mt-4 border rounded-4 mb-3">
                  <div className="card-body">
                    <div className="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-3">
                      <div>
                        <div className="text-muted small text-uppercase fw-semibold">
                          Template promo
                        </div>
                        <h5 className="fw-bold mb-0">Template salvati</h5>
                      </div>

                      <button
                        className="btn btn-outline-primary btn-sm"
                        type="button"
                        onClick={saveTemplate}
                      >
                        Salva come template
                      </button>
                    </div>

                    {templates.length === 0 ? (
                      <div className="alert alert-light border mb-0">
                        Nessun template salvato.
                      </div>
                    ) : (
                        <>
                      <div className="table-responsive">
                        <table className="table align-middle mb-0">
                          <thead>
                            <tr>
                              <th>Nome</th>
                              <th>Oggetto</th>
                              <th>Immagine</th>
                              <th></th>
                            </tr>
                          </thead>

                          <tbody>
                            {templates.map((tpl) => (
                              <tr key={tpl.id}>
                                <td className="fw-semibold">{tpl.name}</td>
                                <td>{tpl.subject}</td>
                                <td>{tpl.image_name || "-"}</td>
                                <td className="text-end">
                                    <button
                                      className="btn btn-outline-secondary btn-sm me-2"
                                      type="button"
                                      onClick={() => setPreviewTemplate(tpl)}
                                    >
                                      Anteprima
                                    </button>
                                  <button
                                    className="btn btn-success btn-sm"
                                    type="button"
                                    onClick={() => loadTemplate(tpl)}
                                  >
                                    Usa per email
                                  </button>
                                      <button
                                        className="btn btn-outline-primary btn-sm ms-2"
                                        type="button"
                                        onClick={() => editTemplate(tpl)}
                                      >
                                        Modifica
                                      </button>
                                    <button
                                      className="btn btn-outline-danger btn-sm ms-2"
                                      type="button"
                                      onClick={() => deleteTemplate(tpl)}
                                    >
                                      Elimina
                                    </button>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                        <div className="small text-muted mt-3">
                          Usa “Usa per email” per caricare oggetto e messaggio del template nella comunicazione da inviare.
                          L'immagine promo va selezionata manualmente prima dell'invio email.
                        </div>
                        </>
                    )}
                  </div>
                </div>

                  {previewTemplate && (
                    <div className="card border rounded-4 m-3 bg-light">
                      <div className="card-body">
                        <div className="d-flex justify-content-between align-items-start gap-3">
                          <div>
                            <div className="text-muted small text-uppercase fw-semibold">
                              Anteprima template
                            </div>
                            <h6 className="fw-bold mb-1">{previewTemplate.name}</h6>
                            <div className="fw-semibold mb-2">{previewTemplate.subject || "-"}</div>
                          </div>
                          <button
                            className="btn btn-outline-secondary btn-sm"
                            type="button"
                            onClick={() => setPreviewTemplate(null)}
                          >
                            Chiudi
                          </button>
                        </div>

                        <div className="small text-muted mb-1">Messaggio</div>
                        <div className="border rounded-3 bg-white p-3" style={{ whiteSpace: "pre-wrap" }}>
                          {previewTemplate.message || "-"}
                        </div>

                        <div className="small text-muted mt-3">
                          Immagine: {previewTemplate.image_name || "-"}
                        </div>
                      </div>
                    </div>
                  )}

                <div className="card-body">
                  <div className="text-muted small text-uppercase fw-semibold mb-2">Anteprima email</div>
                  <h4 className="fw-bold">{subject || "Oggetto email"}</h4>
                  <p style={{ whiteSpace: "pre-wrap" }}>{message}</p>

                  {imagePreview && (
                    <img
                      src={imagePreview}
                      alt="Anteprima promo"
                      className="img-fluid rounded-4 border"
                      style={{ maxHeight: 360, objectFit: "contain" }}
                    />
                  )}

                  <hr />
                  <div className="small text-muted">
                    Ricevi questa comunicazione perché hai dato consenso a ricevere promozioni e offerte da Dallo Zio Roby.
                  </div>
                </div>
              </div>

              <div className="d-flex flex-wrap gap-2 mt-3">
                <button className="btn btn-success" type="button" onClick={sendTestFake}>
                  Prepara mail test
                </button>

                <button className="btn btn-outline-success" type="button" onClick={sendBulk}>
                  Invia email agli iscritti
                </button>
              </div>
            </div>
          </div>

          <div className="card border-0 shadow-sm rounded-4">
            <div className="card border-0 shadow-sm rounded-4 mb-3">
              <div className="card-body">
                <h5 className="fw-bold mb-3">📜 Ultime campagne inviate</h5>

                {campaigns.length === 0 ? (
                  <div className="alert alert-light border mb-0">
                    Nessuna campagna inviata finora.
                  </div>
                ) : (
                  <div className="table-responsive">
                    <table className="table align-middle">
                      <thead>
                        <tr>
                          <th>Data</th>
                          <th>Oggetto</th>
                          <th>Destinatari</th>
                          <th>Inviate</th>
                          <th>Errori</th>
                          <th>Immagine</th>
                          <th>Utente</th>
                        </tr>
                      </thead>
                      <tbody>
                        {campaigns.map((c) => (
                          <tr key={c.id}>
                            <td>{c.created_at ? new Date(c.created_at).toLocaleString("it-IT") : "-"}</td>
                            <td className="fw-semibold">{c.subject}</td>
                            <td>{c.recipients_count}</td>
                            <td>{c.sent_count}</td>
                            <td>{c.failed_count}</td>
                            <td>{c.image_name || "-"}</td>
                            <td>{c.created_by || "-"}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            </div>

            <div className="card-body">
              <h5 className="fw-bold mb-3">Elenco iscritti</h5>

              {clienti.length === 0 ? (
                <div className="alert alert-warning mb-0">
                  Nessun cliente app con consenso marketing attivo.
                </div>
              ) : (
                <div className="table-responsive">
                  <table className="table align-middle">
                    <thead>
                      <tr>
                        <th>Cliente</th>
                        <th>Email</th>
                        <th>Codice</th>
                        <th>Store</th>
                      </tr>
                    </thead>
                    <tbody>
                      {clienti.map((c) => (
                        <tr key={c.id || c.code}>
                          <td>{c.name || `${c.first_name || ""} ${c.last_name || ""}`}</td>
                          <td>{c.email}</td>
                          <td>{c.code}</td>
                          <td>{c.store_ref_label || c.store || "-"}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}

              {emails.length > 0 && (
                <div className="mt-3">
                  <label className="form-label fw-semibold">Email iscritte marketing</label>
                  <textarea
                    className="form-control"
                    rows="4"
                    readOnly
                    value={emails.join(", ")}
                  />
                  <div className="form-text">
                    Uso interno gestionale. Nell'invio reale useremo invio singolo o BCC per privacy.
                  </div>
                </div>
              )}
            </div>
          </div>
        </>
      )}
    </div>
  );
}
